import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

import 'moment-timezone'
import moment from 'moment'
import { languages } from '@/types/languages'
import { i18n } from '@/plugins/i18n'

@Mixin
export default class MomentMixin extends Vue {
    iso8601(date = new Date()) {
        return moment(date).toISOString(true)
    }
    get locale6391() {
        let result = languages.find((item) => item['639-2'] == i18n.locale)?.['639-1']
        return result ? result : 'nb'
    }

    get localMoments() {
        let lang = languages.find((item) => item['639-2'] == i18n.locale)?.['639-1']

        if (lang?.includes('no')) {
            lang = 'nb'
        }

        return lang ? lang : 'nb'
    }

    get allTimeZones() {
        return moment.tz.names()
    }

    getOffset(timezone: any) {
        return moment.tz(timezone).utcOffset()
    }

    formatWithOffsett(date: any, timezone: any) {
        return moment(date).tz(timezone)
    }

    guessTimezone() {
        return moment.tz.guess(true)
    }

    get getDeviceTimeZone() {
        return moment.tz.guess(true)
    }

    formatDate(date: string, timeZone?: string, format?: string) {
        return date
            ? timeZone
                ? moment(new Date(date)).tz(timeZone).locale(this.localMoments).format(format)
                : moment(new Date(date)).locale(this.localMoments).format(format)
            : ''
    }

    calendarDate(date: string, timeZone?: string) {
        return date
            ? timeZone
                ? moment(new Date(date)).tz(timeZone).locale(this.localMoments).calendar()
                : moment(new Date(date)).locale(this.localMoments).calendar()
            : ''
    }

    timeFrom(start: any, end: any, type?: boolean) {
        moment.locale(this.localMoments)
        return moment(start).from(moment(end), type)
    }

    fromNow(date: string, timeZone?: string) {
        return date
            ? timeZone
                ? moment(new Date(date)).tz(timeZone).locale(this.localMoments).fromNow()
                : moment(new Date(date)).locale(this.localMoments).fromNow()
            : ''
    }
}
